import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { FieldworkData } from "../models/fieldwork";
import { EolService } from "./eol.service";

@Injectable({
  providedIn: "root"
})
export class EolDataStoreService {
  private _fieldworkData$ = new BehaviorSubject<FieldworkData | null>(null);

  constructor(private eolService: EolService) {}

  get fieldworkData$(): Observable<FieldworkData | null> {
    return this._fieldworkData$.asObservable();
  }

  get fieldworkData(): FieldworkData | null {
    return this._fieldworkData$.getValue();
  }

  loadFieldworkData(): void {
    this.eolService.retrieveFieldworkData().pipe(
      tap((response: any) => {
        this._fieldworkData$.next(response?.data ?? response);
      })
    ).subscribe();
  }
}
